import { create } from 'zustand'

interface FormDirtyState {
  isDirty: boolean
  setIsDirty: (value: boolean) => void
  reset: () => void
}

export const useFormDirtyStore = create<FormDirtyState>(set => ({
  isDirty: false,
  setIsDirty: value => set({ isDirty: value }),
  reset: () => set({ isDirty: false })
}))
